<template>
  <table class="product-offer-table uk-table uk-table-divider uk-table-justify">
    <thead>
      <tr>
        <th>
          <!-- Status -->
        </th>
        <th>
          <!-- Vertrag? -->
        </th>
        <th>
          {{$t('fields.onetimePrice')}}
        </th>
        <th>
          {{$t('fields.monthlyPrice')}}
        </th>
        <th>
          {{$t('fields.tenants')}}
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <product-offer-table-row
        v-for="offer in offers"
        :key="offer.id"
        :offer="offer"
      />
    </tbody>
  </table>
</template>

<script>
import ProductOfferTableRow from '@/components/ProductOfferTableRow';

export default {
  name: 'product-offer-table',
  props: {
    offers: {
      type: Array,
      required: true,
    },
  },
  components: {
    ProductOfferTableRow,
  },
  i18n: {
    messages: {
      de: {
        fields: {
          onetimePrice: 'Einmaliger Preis',
          monthlyPrice: 'Monatlicher Preis',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductOfferTable.vue?0fe99f15